import { render, staticRenderFns } from "./BlinQ.vue?vue&type=template&id=6c55e51a&scoped=true&"
import script from "./BlinQ.vue?vue&type=script&lang=js&"
export * from "./BlinQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c55e51a",
  null
  
)

export default component.exports